import $ from 'jquery';
import { FireComponent } from '@base';

export class MediaCarousel extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $rightArrow: this.$component.find('[data-right-arrow]'),
      $leftArrow: this.$component.find('[data-left-arrow]'),
    };
  }

  _maybeOverrideBux() {
    /**
     * when component is a carousel (more than 1 child)
     * and it's nested within a tab content container
     * that is not active, the right arrow will be set
     * to display: none;
     * this will check for and override to display: flex;
     */

    // check if component is a carousel
    if (this.elements.$rightArrow.length) {
      // check if its nested within a tab content container
      // and is not active
      if (this.$component.get(0).closest('[data-tab-content]:not(.active)')) {
        // show the right arrow
        this.elements.$rightArrow.get(0).style.display = 'flex';
      }
    }
  }

  _repositionArrows() {
    /**
     * if any media items have a caption,
     * the left/right arrows are vertically centered
     * with the media and caption instead of just the media.
     * This will position the arrows vertically centered
     * with the media item only
     */

    // check if it's a carousel and if there are any captions in the carousel. otherwise do nothing.
    if (this.elements.$rightArrow.length && this.$component.find('.bux-media-carousel__caption').length) {
      const firstCard = this.$component.find('.bux-card').get(0);
      const firstMediaItem = this.$component.find('.bux-card [data-media-item]').get(0).querySelector('img');
      const cardHeight = firstCard.clientHeight;
      const mediaHeight = firstMediaItem.clientHeight;
      const bottomOffset = cardHeight - mediaHeight;

      this.elements.$rightArrow.get(0).parentNode.style.bottom = `${bottomOffset}px`;
      this.elements.$rightArrow.get(0).parentNode.style.height = 'auto';

      this.elements.$leftArrow.get(0).parentNode.style.bottom = `${bottomOffset}px`;
      this.elements.$leftArrow.get(0).parentNode.style.height = 'auto';
    }
  }

  init() {
    if (this.componentExists) {
      this._maybeOverrideBux();
      this._repositionArrows();
    }
  }
}
